module.exports = __webpack_public_path__ + "media/static/icons/icon-tidal-range--blue-368ad0eecc3483adc83360d1f688aad9.svg";